/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'allianz': {
    width: 154,
    height: 154,
    viewBox: '0 0 154 154',
    data: '<path pid="0" fill-rule="evenodd" d="M87.22 117.272V37c0-6.473-2.724-8.585-8.857-8.585H59.964v8.858h2.045c3.407 0 4.77 1.295 4.77 5.247v74.752H87.22zm10.903 0h19.762V56.693c0-6.132-2.726-8.585-8.858-8.585H98.123v69.164zm-42.247 0V48.108H44.973c-6.132 0-8.858 2.453-8.858 8.586v60.578h19.76zm85.177-40.34c0 37.546-27.257 64.939-64.053 64.939-36.797 0-64.054-27.393-64.054-64.94 0-37.545 27.257-64.938 64.054-64.938 36.796 0 64.053 27.393 64.053 64.939zm12.947 0C154 32.98 121.292 0 77 0 33.389 0 0 32.98 0 76.932 0 121.019 33.389 154 77 154c44.292 0 77-32.981 77-77.068z" _fill="#FFF"/>'
  }
})
